import { IAIWorkspace, IAIWorkspaceRequest } from "@entities/aiWorkspace";
import { DraftVetDetail } from "./DraftVetDetail";
import { DraftVetList } from "./DraftVetList";

type DraftVetTabProps = {
  workspace: IAIWorkspace;
  requests: IAIWorkspaceRequest[];
  requestId: string;
  onOpenRequest: (requestId: string, type: string) => void;
  onCloseRequest: () => void;
};

export function DraftVetTab({
  workspace,
  requests,
  requestId,
  onOpenRequest,
  onCloseRequest,
}: DraftVetTabProps) {
  return (
    <div>
      {requestId ? (
        <DraftVetDetail
          requestId={requestId}
          workspace={workspace}
          onBack={onCloseRequest}
          onOpenRequest={onOpenRequest}
        />
      ) : (
        <DraftVetList
          workspace={workspace}
          requests={requests}
          onOpenRequest={onOpenRequest}
        />
      )}
    </div>
  );
}
